module.exports = __webpack_public_path__ + "img/QA.8ba8c989.svg";